import { useSyncExternalStore } from "react";

import { ResolvedDateTimeFormat } from "./format";
import { getActiveDateTimeFormat, subscribeDateTimeFormat } from "./registry";

/**
 * React hook returning the active resolved date/time formatter. Components
 * that format dates inline should use this so they re-render when the user
 * changes their preference. Backed by the same registry the pure
 * `formatters` read, via `useSyncExternalStore`, so it works regardless of
 * provider nesting (defaults to the locale format before config loads).
 */
export function useDateTimeFormat(): ResolvedDateTimeFormat {
  return useSyncExternalStore(
    subscribeDateTimeFormat,
    getActiveDateTimeFormat,
    getActiveDateTimeFormat,
  );
}
